import {
  Box,
  IconButton,
  Image,
  Tooltip,
} from '@chakra-ui/react';
import React from 'react';
import ListIcon from '../../assets/icons/list-icon.svg' ;
import TableIcon from '../../assets/icons/table-icon.svg';

type ViewToggleProps = {
  setViewMode: (
    viewMode: 'list' | 'table'
  ) => void;
  viewMode: 'list' | 'table';
};

const ViewToggle: React.FC<ViewToggleProps> = ({
  setViewMode,
  viewMode,
}) => {
    const onListClick = () => {
    setViewMode('list');
  };

  const onTableClick = () => {
    setViewMode('table');
  };

  return (
    <Box display="inline-flex" mr="0.75rem">
      <Tooltip label="List view">
        <IconButton
          aria-label="List view"
          icon={<Image src={ListIcon} />}
          onClick={onListClick}
          backgroundColor={
            viewMode === 'list'
              ? 'border.gray'
              : 'background.secondary'
          }
          _hover={{ bg: 'border.gray' }}
          borderRadius="0.375rem"
          borderRight="none"
          borderTopRightRadius={0}
          borderBottomRightRadius={0}
          height="2.5rem"
          padding="0rem 0.5rem"
          width="50%"
        />
      </Tooltip>
      <Tooltip label="Table view">
        <IconButton
          aria-label="Table view"
          icon={<Image src={TableIcon} />}
          onClick={onTableClick}
          backgroundColor={
            viewMode === 'table'
              ? 'border.gray'
              : 'background.secondary'
          }
          _hover={{ bg: 'border.gray' }}
          borderRadius="0.375rem"
          borderTopLeftRadius={0}
          borderBottomLeftRadius={0}
          height="2.5rem"
          padding="0rem 0.5rem"
          width="50%"
        />
      </Tooltip>
    </Box>
  );
};

export default ViewToggle;
